import COUNTRIES from '../countries.translations'

import translations from './silicon.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/silicon'

export const silicon: Metal = {
  id: 38,
  slug: 'silicon',
  name: t.name,
  symbol: 'Si',
  // The sheet's pins are silicon-metal processing facilities, not quartz mines —
  // silicon metal is produced by reducing high-purity quartz in electric arc furnaces.
  mines: [
    {
      name: 'Leshan (China, silicon processing)',
      region: t.mine0Region,
      slug: 'leshan',
      coordinates: [103.77, 29.55],
    },
    {
      name: 'Shihezi (China, silicon processing)',
      region: t.mine1Region,
      slug: 'shihezi',
      coordinates: [86.04, 44.31],
    },
    {
      name: 'Burghausen (Germany, silicon processing)',
      region: t.mine2Region,
      slug: 'burghausen',
      coordinates: [12.83, 48.17],
    },
    {
      name: 'Alloy, Fayette County (USA, silicon processing)',
      region: t.mine3Region,
      slug: 'alloy',
      coordinates: [-81.1, 38.0],
    },
    {
      name: 'Xuzhou (China, silicon processing)',
      region: t.mine4Region,
      slug: 'xuzhou',
      coordinates: [117.28, 34.21],
    },
  ],
  countries: [
    { name: COUNTRIES.china, percent: 84.8 },
    { name: COUNTRIES.brazil, percent: 4.1 },
    { name: COUNTRIES.norway, percent: 2.6 },
    { name: COUNTRIES.france, percent: 2 },
    { name: COUNTRIES.germany, percent: 1.3 },
    { name: COUNTRIES.russia, percent: 1.1 },
  ],
  content: {
    smartphone: {
      quantityScore: 5,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'electronics', 'camera'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 3, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
    },
  },
}
